export * from './LogoFigmaIcon';
export * from './LogoFigmaIcon16Light';
export * from './LogoFigmaIcon16Regular';
export * from './LogoFigmaIcon16Solid';
export * from './LogoFigmaIcon20Light';
export * from './LogoFigmaIcon20Regular';
export * from './LogoFigmaIcon20Solid';
export * from './LogoFigmaIcon24Regular';
export * from './LogoFigmaIcon24Solid';
export * from './LogoFigmaIcon32Regular';
export * from './LogoFigmaIcon64Regular';
